export {PersonalRankSummaryConnected as PersonalRankSummary} from './PersonalRankSummary.connect';
